<div class="container-filter" (click)="close()" [formGroup]="regForm" >
  <!-- BUSCA SUPERIOR -->
  <div class="reg-filter">
    <div class="reg-element">
      <app-autocomplete *ngIf="featureInputSearch" inputId="team-management-autocomplete" placeholder="Busca"
        [height]="'36px'" [emitIndex]="true"
        [autoSearchResults]="autoSearchResults" [onlyDescription]="false" [defaultValue]="inputSearchValue"
        (ElementSelected)="patchInputValue($event)" (autocompleteSearch)="searchInput($event)"
        value="value" [enhanveOnHover]="false">
      </app-autocomplete>
      
      <div class="reg-input" *ngIf="!featureInputSearch">
        <input type="text" id="product-reg-search"
          name="reg-search" class="reg-input-control"
          placeholder="Busca" formControlName="searchTerm"
          (input)="searchInput($event.target.value)"
          (keydown.enter)="autocomp = false" (keydown)="downList($event)">
        <button class="btn-search">
          <img src="../../assets/svgs/search.svg" alt="Buscar">
        </button>
      </div>
      <div class="reg-itens-filter">
        <button id="reg-disply-filter-btn" class="btn-filter" (click)="showFilter()">
          <img src="../../assets/svgs/funnel.svg" alt="Filtro Inativo" *ngIf="!displayFilter">
          <img src="../../assets/svgs/funnel_act.svg" alt="Filtro Ativo" *ngIf="displayFilter">
        </button>
        <img class="reg-dot-alert" src="../../assets/svgs/dot-alert.svg" alt="Alerta" *ngIf="validatorDot()">
        <button id="reg-display-view-btn" class="btn-filter mr" (click)="changeStructure()">
          <img src="../../assets/svgs/i_open_active.svg" alt="Cards" *ngIf="!displayList">
          <img src="../../assets/svgs/i_open.svg" alt="Lista" *ngIf="displayList">
        </button>
        <button id="reg-display-map-btn" class="btn-filter btn-act mr" (click)="showMap()">
          <img src="../../assets/svgs/i_properties_map.svg" alt="Mapa Inativo" *ngIf="!displayMap">
          <img src="../../assets/svgs/i_properties_map_active.svg" alt="Mapa Ativo" *ngIf="displayMap">
        </button>
        <lib-button-tertiary class="btn-properties" (click)="registerNewProp()">Cadastrar imóvel</lib-button-tertiary>
      </div>
    </div>
    <lib-button-secondary class="order" (click)="registerNewProp()">Cadastrar imóvel</lib-button-secondary>
  </div>

  <div class="reg-input-autocomplete" *ngIf="autocomp && autoSearchResults.length > 0 && !featureInputSearch">
    <div id="autocomplete-result-{{i}}" class="autocomplete-item" *ngFor="let result of autoSearchResults; let i = index" [ngClass]="{'keyHover': i === autocompIdx}" (pointerover)="pointerSelection(i)" (click)="patchInputValue(result)">
      <span *ngIf="result.tag === 'SKU'">Código</span>
      <span *ngIf="result.tag === 'PLACE'">Em Região</span>
      <span *ngIf="result.tag === 'BRAND_NEW'">Em Lançamentos</span>
      <span>:&nbsp;</span>
      <span class="value" [innerHTML]=result.label></span>
    </div>
  </div>

  <!-- LIST-TAGS -->
  <ul class="tags-list" *ngIf="tags.length">
    <li class="tags-item" *ngFor="let tag of tags; let i = index">
      <a class="tags-action" id="tags-{{tag.name}}">
        <p><span *ngIf="tag.tag === 'SKU'">Código</span>
          <span *ngIf="tag.tag === 'PLACE'">Em Região</span>
          <span *ngIf="tag.tag === 'BRAND_NEW'">Em Lançamentos</span>: <span class="value" [innerHTML]=tag.label></span></p>
        <button id="remove-tag-btn-{{i}}" class="btn-clear-tag" (click)="removeTags(tag.value, i)">
          <img src="../../assets/svgs/i_clear.svg" alt="Deletar tag">
        </button>
      </a>
    </li>
  </ul>

  <!-- FILTER -->
  <form class="more-filter" *ngIf="displayFilter">
    <div class="container-form">
      <div class="stl">
        <div class="select-filter">
          <app-select-options
            [text]="regForm.get('temp').value ? regForm.get('temp').value : 'Temperatura'"
            [changeLate]="true"
            [listOptions]="listTemperature"
            (sendChange)="changeTempData($event)">
          </app-select-options>
        </div>
        <div class="select-filter">
          <app-select-options
            [text]="regForm.get('late').value ? regForm.get('late').value : 'Vencimento'"
            [changeLate]="true"
            [listOptions]="listChanger"
            (sendChange)="changeDataLate($event)">
          </app-select-options>
        </div>
      </div>
      <div class="list-checked">
        <lib-input-checkbox class="item-action" id="favorite" name="favorite" label="Favoritas" formControlName="isFavorite" (click)="selectField('isFavorite')"></lib-input-checkbox>
        <lib-input-checkbox class="item-action" id="corporator" name="corporator" label="É do incorporador" formControlName="corporator" (click)="selectIncorporator()"></lib-input-checkbox>
        <lib-input-checkbox class="item-action" id="notCorporator" name="notCorporator" label="Não é do incorporador" formControlName="notCorporator" (click)="selectNotCorp()"></lib-input-checkbox>
        <lib-input-checkbox class="item-action" id="archived" name="archived" label="Facs arquivadas" formControlName="archived" (click)="selectField('archived')"></lib-input-checkbox>
      </div>
    </div>
    <div class="filter-actions">
      <div class="btn-reset">
        <lib-button-tertiary (click)="resetForm()">Limpar</lib-button-tertiary>
      </div>
     <lib-button-primary (click)="initFormRouter()">Filtrar</lib-button-primary>
    </div>
  </form>
</div>

<div class="card-template" *ngIf="!displayList">
  <div class="ml"></div>
  <div class="cards">
    <!-- <app-properties-card class="card-item" *ngFor="let card of listTableOld" [itemCard]="card"></app-properties-card> -->
    <app-properties-card class="card-item" *ngFor="let card of listTable" [itemCard]="card"></app-properties-card>
  </div>
  <div class="mr"></div>
</div>

<div class="tbl-container" *ngIf="displayList">
  <div class="tbl">
    <app-properties-table [listTable]="listTable" ></app-properties-table>
  </div>
</div>

<app-product-registration (closeNewProduct)="closeProductRegistration()" *ngIf="showPropRegistration"></app-product-registration>